import React, { useContext, useEffect } from "react";
import { I18nContext } from "../i18n";
import Container from "react-bootstrap/Container";
import MobileNavbar from "../components/header/MobileNavbar";
import ExpandedNavbar from "../components/header/ExpandedNavbar";
import "../scss/styles/app.scss";
import SearchForm from "../components/SearchForm/SearchForm";
import UseWindowSize from "../customHooks/useWindowSize";
import { withRouter } from "react-router-dom";
import { bootStrapGrid } from "../constants/constants";
import Footer from "../components/common/Footer";

const SearchPage = (props) => {
  const { translate } = useContext(I18nContext);
  const size = UseWindowSize();
  document.title = translate("search_trademark") + " | PRH";

  useEffect(() => {
    props.pathParams.updateLanguage();
    props.setActiveLink("Search");
  }, []);

  return (
    <>
      <Container fluid="true" className="flex-wrapper m-0 p-0">
        <div>
          <div id="skip">
            <a href="#search_content">{translate("jumplink_to_content")}</a>
          </div>
          {size.width < bootStrapGrid.md ? (
            <MobileNavbar pathParams={props.pathParams} />
          ) : (
            <ExpandedNavbar
              activeLink={props.activeLink}
              pathParams={props.pathParams}
            />
          )}
          <main id="search_content" tabIndex="-1">
            <SearchForm
              setSearchParams={props.setSearchParams}
              searchParams={props.searchParams}
              fetchSearchResults={props.fetchSearchResults}
              pathParams={props.pathParams}
            />
          </main>
        </div>
        <Footer />
      </Container>
    </>
  );
};

export default withRouter(SearchPage);
